import React, { useRef, useState } from 'react'
import { signup } from '../helpers/auth';
import Footer from './Sections/Footer'
import Header from './Sections/Header'

const SignUpScreen = () => {

    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    const repasswordRef = useRef(null);
    const usernameRef = useRef(null);
    const [error, setError] = useState("");

    const handleSubmit = async () => {
        const email = emailRef.current.value;
        const password = passwordRef.current.value;
        const repassword = passwordRef.current.value;
        const username = usernameRef.current.value ? usernameRef.current.value : "";

        if (email.trim() && password.trim() && repassword.trim()) {
            if (password === repassword) {
                try {
                    const result = await signup(email, password, username);
                    if (!result.success) {
                        setError(result.error.message);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setError('Les deux mots de passe ne correspondent pas !');
            }
        } else {
            setError('Veuillez remplir tous les champs !');
        }
    }

    return (
        <div id="wrapper">
            {/* <Header /> */}
            <div uk-height-viewport="" className="uk-flex uk-flex-middle">
                <div className="uk-width-2-3@m uk-width-1-2@s m-auto rounded">
                    <div className="uk-child-width-1-2@m uk-grid-collapse bg-gradient-grey" uk-grid="">

                        <div className="uk-margin-auto-vertical uk-text-center uk-animation-scale-up p-3 uk-light">
                            <i className=" uil-graduation-hat icon-large"></i>
                            <h3 className="mb-4"> Leo Tech's Academy</h3>
                            <p>Le lieu où vous pouvez apprendre toute choses. </p>
                        </div>

                        <div className="uk-card-default p-5 rounded">
                            <div className="mb-4 uk-text-center">
                                <h3 className="mb-0"> Bienvenue !</h3>
                                <p className="my-2">Inscrivez-vous et commencer à vous former.</p>
                            </div>
                            <form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>

                                {error != "" && <div className="alert alert-danger">
                                    {error}
                                </div>}

                                <div className="uk-form-group">
                                    <label className="uk-form-label"> Nom d'utilisateur</label>

                                    <div className="uk-position-relative w-100">
                                        <span className="uk-form-icon">
                                            <i className="icon-feather-mail"></i>
                                        </span>
                                        <input ref={usernameRef} required className="uk-input" type="text" placeholder="John Doe" />
                                    </div>

                                </div>

                                <div className="uk-form-group">
                                    <label className="uk-form-label"> Email</label>

                                    <div className="uk-position-relative w-100">
                                        <span className="uk-form-icon">
                                            <i className="icon-feather-mail"></i>
                                        </span>
                                        <input ref={emailRef} required className="uk-input" type="email" placeholder="name@example.com" />
                                    </div>

                                </div>

                                <div className="uk-form-group">
                                    <label className="uk-form-label"> Mot de passe</label>

                                    <div className="uk-position-relative w-100">
                                        <span className="uk-form-icon">
                                            <i className="icon-feather-lock"></i>
                                        </span>
                                        <input ref={passwordRef} required className="uk-input" type="password" placeholder="********" />
                                    </div>

                                </div>

                                <div className="uk-form-group">
                                    <label className="uk-form-label"> Confirmer le mot de passe</label>

                                    <div className="uk-position-relative w-100">
                                        <span className="uk-form-icon">
                                            <i className="icon-feather-lock"></i>
                                        </span>
                                        <input ref={repasswordRef} required className="uk-input" type="password" placeholder="********" />
                                    </div>

                                </div>

                                <div className="mt-4 uk-flex-middle uk-grid-small" uk-grid="">
                                    <div className="uk-width-expand@s">
                                        <p> Déjà inscrit? <a href="/connexion">Connectez-vous !</a></p>
                                    </div>
                                    <div className="uk-width-auto@s">
                                        <button type="submit" className="btn btn-default">S'inscrire</button>
                                    </div>
                                </div>

                            </form>
                        </div>

                    </div>
                </div>
            </div>
            {/* <Footer /> */}
        </div>
    )
}

export default SignUpScreen
